import DescopeSignupWidgetView from './DescopeSignupWidgetView.vue';

export const type = 'descopeSignup';
export const view = DescopeSignupWidgetView;

export function builder() {
  return {
    type,
    top: 0,
    rotate: 0,
    zIndex: 1,
    descopeFlowId: '',
  };
}
